import { NotifierService } from 'angular-notifier';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApplicationUser } from '../shared/models/applicationUser.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable()
export class ApplicationUserService {
  status: string = '';
  uid: string = '';
  userSavedStatus: boolean = false;
  userDeletedStatus: boolean = false;
  constructor(
    private afAuth: AngularFireAuth,
    private http: HttpClient,
    private notifierService: NotifierService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  apiUrl = environment.apiURL;
  public saveApplicationUserURL =
    environment.apiURL + '/rest/admin/applicationusers';
  public editApplicationUserURL =
    environment.apiURL + '/rest/admin/applicationusers';
  public listApplicationUsersURL =
    environment.apiURL + '/rest/admin/applicationusers/list';
  public deleteApplicationUsersURL =
    environment.apiURL + '/rest/admin/applicationusers/delete/';
  public getUserDetailsUrl = environment.apiURL + '/rest/user/details';
  async saveCredentialsToFireBase(
    userName: string,
    password: string,
    role: string,
    sinequaProfile: string,
    contactEmail: string,
    company: string
  ) {
    this.spinner.show();
    userName = userName.replace(/ /g, '');
    const userNameForDatastore = userName;
    userName = userName + '@add-sds-email.com';
    if (userName && password) {
      this.saveUserToApplicationUserTable(
        userNameForDatastore,
        role,
        sinequaProfile,
        contactEmail,
        company,
        this.uid,
        password
      );
    }
  }

  saveUserToApplicationUserTable(
    username: string,
    role: string,
    sinequaProfile: string,
    contactEmail: string,
    company: string,
    uid: string,
    password: string
  ) {
    const url = `${this.saveApplicationUserURL}`;
    const user = new ApplicationUser(
      username,
      role,
      sinequaProfile,
      contactEmail,
      company,
      uid,
      password
    );

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<ApplicationUser>(url, user).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.userSavedStatus = true;
      },
      (err: any) => {
        try {
          if (
            err.error.includes('User Name') &&
            err.error.includes('is already taken')
          ) {
            this.notifierService.notify(
              'warning',
              `User Name ${username} is already taken`
            );
            this.spinner.hide();
          }
        } finally {
          if (err.error.text.includes('User saved successfully')) {
            this.userSavedStatus = true;
            this.router.navigate(['/application-user-list']);
            this.notifierService.notify('success', `User Successfully added`);
            this.spinner.hide();
          }
        }
      }
    );
  }
  data = ([] = []);
  private currentUserDetailsSubject = new BehaviorSubject<any>(null);
  currentUserDetails$ = this.currentUserDetailsSubject.asObservable();
  getUsers(query: string) {
    const url = `${this.listApplicationUsersURL}?search=${query}`;
    return this.http.get(url);
  }
  get currentUserDetails(): any {
    return this.currentUserDetailsSubject.value;
  }

  set currentUserDetails(userDetails: any) {
    this.currentUserDetailsSubject.next(userDetails);
    // Optionally, you can store the user details in another persistent way if needed
  }
  getuserDetails(userName: string) {
    const url = `${this.getUserDetailsUrl}?userName=${userName}`;
    return this.http.get(url);
  }
  async deleteUser(username: string) {
    this.spinner.show();

    return this.http
      .delete(this.deleteApplicationUsersURL + username, {
        responseType: 'text',
      })
      .subscribe((data: any) => {
        this.spinner.hide();
        this.notifierService.notify('success', 'User successfully Deleted');
        this.userDeletedStatus = true;
        const emtpyQuery = '';
        this.getUsers(emtpyQuery).subscribe((response: any) => {
          this.data = response; // Populate the data array with the API response
          this.spinner.hide();
        });
      });
  }
  editUserDetails(
    username: string,
    role: string,
    sinequaProfile: string,
    contactEmail: string,
    company: string,
    uid: string,
    password: string
  ) {
    this.spinner.show();

    const user = new ApplicationUser(
      username,
      role,
      sinequaProfile,
      contactEmail,
      company,
      uid,
      password
    );
    sessionStorage.setItem('user', JSON.stringify(user));

    return this.http
      .put(this.editApplicationUserURL, user, { responseType: 'text' })
      .subscribe((data: any) => {
        this.router.navigate(['/application-user-list']);
        this.spinner.hide();
        this.notifierService.notify('success', 'User successfully updated');
      });
  }
  private user: any;

  setUser(user: any) {
    this.user = user;
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  getUser() {
    if (!this.user) {
      const storedUser = sessionStorage.getItem('user');
      this.user = storedUser ? JSON.parse(storedUser) : null;
    }
    return this.user;
  }

  clearUser() {
    this.user = null;
    sessionStorage.removeItem('user');
  }
  saveLoginInfo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/rest/login/report`);
  }
}
